var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('v-chatRoom',{attrs:{"chatRoomType":_vm.chatRoomType,"sendParams":_vm.sendParams,"getListParams":_vm.getListParams,"delMsgParams":_vm.delMsgParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }